import { updateSearcherHome } from '@slices/propertiesSlice'
import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { SearcherFilterData } from 'types'
const Autocomplete_1 = ({
  lang,
  updateRoute,
  searchHome,
}: {
  lang: string[]
  updateRoute?: any
  searchHome?: SearcherFilterData
  dispatch?: any
}) => {
  const [searchtext, setSearchtext] = useState('')
  const [suggest, setSuggest] = useState<string[]>([])
  const [resfound, setResfound] = useState(true)
  const dispatch = useDispatch()

  const handleChange = (e: any) => {
    let searchval = e.target.value
    let suggestion: string[] = []
    console.log(lang)
    if (searchval.length > 0) {
      console.log(lang)
      suggestion = lang?.sort().filter((e) => e.toLowerCase().includes(searchval.toLowerCase()))
      setResfound(suggestion.length !== 0 ? true : false)
    }
    setSuggest(suggestion)
    setSearchtext(searchval)
  }

  const suggestedText = (value: string) => {
    setSearchtext(value)
    setSuggest([])
  }

  useEffect(() => {
    // dispatch(setFilterHome({...searchHome,location:[{"name":searchtext}]}))
    updateRoute({ current: { value: searchtext, name: 'location' } })
    dispatch(
      updateSearcherHome({
        ...searchHome,
        location: [{ id: 0, name: searchtext }],
      }),
    )
  }, [searchtext])

  const getSuggestions = () => {
    if (suggest.length === 0 && searchtext !== '' && !resfound) {
    }

    return (
      <ul className={searchtext && suggest.length > 0 ? 'd-block' : 'd-none'}>
        {suggest.map((item, index) => {
          return (
            <div
              key={index}
              className="d-flex align-items-center w-100 hover-color"
            >
              <li onClick={() => suggestedText(item)}>{item}</li>
              {index !== suggest.length - 1 && <hr />}
            </div>
          )
        })}
      </ul>
    )
  }

  return (
    <div className="searchcontainer">
      <input
        type="text"
        placeholder="Ubicación"
        className="search"
        value={searchtext}
        onChange={handleChange}
      />
      {getSuggestions()}
    </div>
  )
}

export default Autocomplete_1
